import {Component} from "@angular/core";
import {NavController} from "ionic-angular";
import {JobsPage} from "../jobs/jobs.page";

/*
  Generated class for the CvSubmitPage page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  templateUrl: 'cv-submit.page.html',
})
export class CvSubmitPage {

  constructor(public nav: NavController) {}

  done(){
    this.nav.setPages([{page: JobsPage}]);
  }


}



// WEBPACK FOOTER //
// ./src/pages/cv-submit/cv-submit.page.ts